import { FC } from 'react';
import { useUsers } from '../context/UserManagementContext';
import { SwitcherTab } from '@silverfort/sf-components';
import { Redirect, Route, Switch, useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import AdUsers from './AdUsers';
import LocalAccounts from './LocalAccounts';

const AD_USERS_PATH = 'adUsers';
const LOCAL_ACCOUNTS_PATH = 'localAccounts';

const USER_TYPES_TABS = [
    {
        text: 'AD users',
        value: AD_USERS_PATH,
        large: true
    },
    {
        text: 'Local accounts',
        value: LOCAL_ACCOUNTS_PATH,
        large: true
    }
];

const getSelectedTabItem = (path: string): string => {
    const pathElements = path.split('/');

    return pathElements[pathElements.length - 1];
};

const UserManagementRoutes: FC = () => {
    const match = useRouteMatch();
    const history = useHistory();
    const location = useLocation();
    const selectedTabItem = getSelectedTabItem(location.pathname);
    const { toolbarExtraContent } = useUsers();

    const handleSelectTabItem = (value: string) => {
        history.replace(`${match.path}/${value}`);
    };

    return (
        <div id="wrapper" className="h-[calc(100vh-64px)] bg-sf-white flex flex-col mt-[64px] p-0">
            <div className="pt-4 px-6 w-full flex justify-between items-center">
                <SwitcherTab
                    items={USER_TYPES_TABS}
                    onSelect={handleSelectTabItem}
                    selectedItem={selectedTabItem}
                    itemClassName="flex-none w-fit !p-1"
                    tabClassName="flex-none"
                />
                {toolbarExtraContent && <div>{toolbarExtraContent}</div>}
            </div>
            <Switch>
                <Route exact path={`${match.path}/${AD_USERS_PATH}`} component={AdUsers} />
                <Route exact path={`${match.path}/${LOCAL_ACCOUNTS_PATH}`} component={LocalAccounts} />
                <Redirect to={`${match.path}/${AD_USERS_PATH}`} />
            </Switch>
        </div>
    );
};

export default UserManagementRoutes;
